import {PureComponent} from "react"
import {Field, reduxForm} from "redux-form"
import createOnSubmitFailHandler from "../../Form/createOnSubmitFailHandler.js"

import validate from './validate.js'
import Input from "../../Form/Field/Input.jsx"

export const name = 'FreelanceInterviewSummaryStepForm'

class SummaryStepForm extends PureComponent {
  render() {
    return(
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-12">
              <Field
                label={"Décrivez vous et vos attentes, en quelques lignes"}
                name="freelance.summary"
                type="textarea"
                maxLength={1300}
                component={Input}
              />
            </div>
          </div>
          <div className="col-lg-12"><input className="d-none" type="submit" /></div>
        </form>
      </div>)

  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(SummaryStepForm)
